import React, { useCallback, useRef } from 'react';
import { HAPPY_TREE_VALLEY_TUNES, MUSIC_PREVIEW_SECONDS, musicAssetUrl } from '../data/music';

function previewCapSeconds(audio) {
  const duration = audio?.duration;
  if (Number.isFinite(duration) && duration > 0 && duration < MUSIC_PREVIEW_SECONDS) {
    return duration;
  }
  return MUSIC_PREVIEW_SECONDS;
}

function clampPreviewTime(audio) {
  if (!audio) return;
  const cap = previewCapSeconds(audio);
  if (audio.currentTime > cap) {
    audio.currentTime = cap;
  }
}

function stopAtPreviewEnd(audio) {
  if (!audio || audio.paused) return;
  const cap = previewCapSeconds(audio);
  if (audio.currentTime >= cap) {
    audio.pause();
    audio.currentTime = cap;
  }
}

export default function HappyTreeValleyTunes({ compact = false }) {
  const audioRefs = useRef([]);

  const pauseOthers = useCallback(currentIndex => {
    audioRefs.current.forEach((audio, index) => {
      if (index !== currentIndex && audio && !audio.paused) {
        audio.pause();
      }
    });
  }, []);

  const handlePlay = useCallback(
    (index, event) => {
      pauseOthers(index);
      const audio = event.currentTarget;
      if (audio.currentTime >= previewCapSeconds(audio)) {
        audio.currentTime = 0;
      }
    },
    [pauseOthers]
  );

  return (
    <ul className={`tunes-list${compact ? ' tunes-list--compact' : ''}`}>
      {HAPPY_TREE_VALLEY_TUNES.map((track, index) => {
        const src = musicAssetUrl(track.fileName);
        return (
          <li key={track.id} className="tunes-track">
            <div className="tunes-track__meta">
              <h3 className="tunes-track__title">
                {track.title}
                <span className="tunes-track__preview-badge">{MUSIC_PREVIEW_SECONDS}s preview</span>
              </h3>
              <p className="tunes-track__desc">{track.description}</p>
            </div>
            <div className="tunes-track__actions">
              <audio
                ref={el => {
                  audioRefs.current[index] = el;
                }}
                className="tunes-track__player"
                controls
                controlsList="nodownload noplaybackrate"
                preload="none"
                onPlay={event => handlePlay(index, event)}
                onTimeUpdate={event => stopAtPreviewEnd(event.currentTarget)}
                onSeeking={event => clampPreviewTime(event.currentTarget)}
                onSeeked={event => clampPreviewTime(event.currentTarget)}
              >
                <source src={src} type="audio/mpeg" />
                Your browser does not support audio playback.
              </audio>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
